var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tilte-list']},[_c('img',{staticClass:"point-left",attrs:{"src":require('@/assets/daping/point-left.png')}}),_vm._v(" "),_c('div',{class:['title-name']},[_vm._v("\n    "+_vm._s(_vm.titleName)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9e3430","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/patrolScreenMini/components/title-internal.vue
// module id = null
// module chunks = 